export const PRIVATE_ROUTES = {
  APP: '/app',
  DASHBOARD: '/app/dashboard',
  DASHBOARD_TAB: ':tabName',
  DASHBOARD_TAB_NAME: '/app/dashboard/:tabName',
  ADMINISTRATOR: {
    ROOT: '/app/administrator',
    ADMIN_SETTING: 'admin-setting',
    ROLE: 'role',
    ROLE_PATH: '/app/administrator/role',
    CREATE_ROLE: 'create',
    CREATE_ROLE_PATH: 'role/create',
    EDIT_ROLE: ':id/edit',
    EDIT_ROLE_PATH: 'role/:id/edit',
  },
  CUSTOMER: {
    ROOT: '/app/customer',
    CREATE: 'create',
    EDIT: ':id/edit',
  },
  ORDER: {
    ROOT: '/app/order',
    CREATE: 'create',
    EDIT: ':id/edit',
    KIT_SERIAL_GENERATOR: 'kit-serial-generator',
    DETAIL: ':id',
  },
  PRODUCT: {
    ROOT: '/app/product',
    CREATE: 'create',
    DETAIL: ':id',
    EDIT: ':id/edit',
    FULL_DETAIL: '/app/product/:id',
  },
  PROJECT: {
    ROOT: '/app/project',
    CREATE: 'create',
    EDIT: ':id/edit',
    DETAIL: ':id',
  },
  EXTRACTION: {
    ROOT: '/app/extraction',
    CREATE: 'create',
    EDIT: ':extractionId/edit',
    DETAIL: ':extractionId/:displayName',
    FULL_DETAIL: '/app/extraction/:extractionId/:displayName',
  },
  SEQUENCING: {
    ROOT: '/app/sequencing',
    PARTNER: 'partner',
    DETAIL: ':id/:displayId',
  },
  KIT: {
    ROOT: '/app/kit',
    DETAIL: 'detail/:serialId',
    KIT_DETAIL: '/app/kit/detail/:serialId',
  },
  ALERT: {
    ROOT: '/app/alert',
    QC_EDIT: 'qc/detail/:id/edit',
    QC_FULL_DETAIL: 'qc/detail/:id',
    ALERT_TAB: '/:tabName',
    BY_TAB: ':tabName',
    FULL_TAB_NAME: '/app/alert/:tabName',
  },
  EMAIL: '/app/email',
  REPORT: {
    ROOT: '/app/report',
    SIXTEEN_S: '16s',
    BY_TYPE: ':sequencingType',
    REPORT_TAB_TYPE: '/app/report/:sequencingType',
  },
  FMT: {
    ROOT: '/app/fmt',
    BY_TAB: ':tabName',
    FULL_TAB_NAME: '/app/fmt/:tabName',
    DONOR_DETAIL: 'donor/:profileId',
  },
  PROFILE: {
    ROOT: '/profile',
    MANAGE_TAGS: 'manage-tags',
    LOGS: 'logs',
    ADMIN_SETTINGS: 'admin-settings',
    PAGE_SETTINGS: 'page-settings',
    WEBHOOK_RULE: 'webhook-rule',
    DAY_DELAY: 'day-delay',
    LIMIT_CONTENT_CLINIC_ORG: 'limit-content-clinic-org',
    ALLOW_BUCKETS: 'allow-buckets',
    SYSTEM: {
      ROOT: 'system',
      DETAIL: 'detail/:releaseId',
      CREATE: 'create',
      EDIT: ':releaseId/edit',
      FULL_ROOT: '/profile/system',
    },
  },
  ANALYSIS: {
    ROOT: '/app/analysis',
    BY_TAB: ':tabName',
    FULL_TAB_NAME: '/app/analysis/:tabName',
    COMMERCIAL_DETAIL: 'commercial/:displayId',
    RESEARCH_DETAIL: 'research/:displayId',
  },
  ORGANIZATION: {
    ROOT: '/app/organization',
    CREATE: 'create',
    PDF_TEMPLATE_CONFIG: 'pdf-template-config/:templateName',
    BASE_PDF_TEMPLATE_CONFIG: 'base-pdf-template-config',
    DETAIL: ':id',
  },
  JUPITER_LITE: {
    ROOT: 'app/jupiter-lite',
  },
  GOD_MODE: '/app/god-mode',
};

export const PUBLIC_ROUTES = {
  SIGN_IN: '/sign-in',
  RESET_PASSWORD: '/reset-password',
  FORGOT_PASSWORD: '/forgot-password',
  CHALLENGE_RESET_PASSWORD: '/challenge-reset-password',
  RESET_PASSWORD_CONFIRM: '/reset-password-confirmation',
  TWO_FACTOR_CONFIRM: '/two-factor-authentication-confirmation',
  OTP: '/otp',
  PASSWORD_COMPLEXITY: '/password-complexity',
};
